import './babel';
import './DO_NOT_TOUCH/GlobalScope/Polyfill';
import './DO_NOT_TOUCH/GlobalScope';

// styles
import './styles.scss';

// Added mostly for debugging, to know when this file is run
console.log('Signage provided by REACH Media Network (https://reachmedianetwork.com/)');
